'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Check_module = require('./Check.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Check = _ref => {
  let {
    checkStyle = {}
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    className: Check_module["default"].svg,
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 12",
    style: checkStyle
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.7967 0.292892L14.5485 2.04478L4.88621 11.7071L0 6.82089L1.75188 5.06901L4.88621 8.20334L12.7967 0.292892Z"
  }));
};

exports["default"] = Check;
